import { faSync } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useSetState } from '@domain-group/react-hooks'

import {
  Box, Button, Checkbox, ListItem, Text,
} from '@domain-group/suit-theme'

import useInvoice from '@hooks/useInvoice'
import type { XeroInvoice } from '@hooks/useAccountingIntegration'

import handleCallbackAction from '@functions/handleCallbackAction'

interface InvoiceListItemProps {
  agencyId: number,
  xeroInvoice: XeroInvoice,
}

const defaultState = {
  loading: false,
}

const InvoiceListItem = (props: InvoiceListItemProps) => {
  const { agencyId, xeroInvoice } = props

  const [state, setState] = useSetState(defaultState)
  const { loading } = state

  const {
    campaign_id,
    campaign_title,
    external_invoice_id,
    matched,
    reference,
    status,
    synced,
    xero_invoice_number,
  } = xeroInvoice

  const {
    callbacks: {
      importExternalInvoice,
    },
  } = useInvoice(xeroInvoice)

  const importPayload = {
    callbacks: {
      action: importExternalInvoice,
      afterAction: () => setState({ loading: false }),
    },
    entityParams: { agency_id: agencyId, campaign_id, external_invoice_id },
    toastText: 'Imported Invoice',
  }

  return (
    <Box variant="white" marginBottom="large">
      <Box flexDirection="column" minWidth={0}>
        {/*
         // @ts-expect-error TS2339 */}
        <ListItem.WithCheckbox
          boxProps={{ padding: 'medium' }}
          checkbox={(
            <Checkbox
              checked={matched}
            />
          )}
          disableHover
        >
          <Box flexDirection="column" width="auto" marginRight="auto">
            <Text fontSize="small">{xero_invoice_number || 'No ID Number'}</Text>

            <Box>
              <Text color="bodyFontLightColor" fontSize="xsmall" marginRight="medium" marginTop="medium">
                {reference || 'No Reference'}
              </Text>
            </Box>
          </Box>

          {matched && !synced && (
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faSync} />}
              loading={loading}
              onClick={() => {
                setState({ loading: true })
                // @ts-expect-error TS2345
                handleCallbackAction(importPayload)
              }}
              size="small"
              width={['100%', 'fit-content']}
            >Import
            </Button>
          )}
          {/*
         // @ts-expect-error TS2339 */}
        </ListItem.WithCheckbox>

        <Box justifyContent="space-between" padding="large">
          <Text color="bodyFontLightColor" fontSize="xsmall" width="fit-content">
            {status}
          </Text>

          <Text
            color="bodyFontLightColor"
            fontSize="xsmall"
            textAlign="right"
          >
            {campaign_title}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

export default InvoiceListItem
